import React__default from 'react';
import { M as MENTION_USER_LABEL_CLASSNAME } from '../consts-b4cb83cf.js';
function MentionUserLabel(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$isReverse = _ref.isReverse,
    isReverse = _ref$isReverse === void 0 ? false : _ref$isReverse,
    color = _ref.color,
    userId = _ref.userId;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(MENTION_USER_LABEL_CLASSNAME, " ").concat(className, " ").concat(isReverse ? 'reverse' : '', " ").concat(color),
    contentEditable: false,
    "data-userid": userId,
    "data-sb-mention": true
  }, children);
}
export { MentionUserLabel as default };